import React from 'react';

export default function Privacy() {
  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <h1 className="text-4xl font-bold text-charcoal">Privacy Policy</h1>
        <p className="text-gray-600">
          We collect the minimum personal data required to coordinate a call and deliver content. Information is stored securely, never sold, and used only for the stated purpose.
        </p>
        <p className="text-gray-600">
          Cookies track consented activity; you may opt out by clearing cookies or contacting hello@taxstrategycenter.com.
        </p>
      </div>
    </div>
  );
}
